import styled from "styled-components";

const Headline = styled.h1`
  color: #ffffff;
  font-size: 3rem;
  font-weight: 400;
  line-height: 1.25;
  margin: 0;
  padding: 0;

  @media (max-width: 576px) {
    font-size: 36px;
  }
`;

export default Headline;



// WEBPACK FOOTER //
// ./src/components/Headline/index.jsx